import React from "react";

const InitialWelcomeScreen = ({ handlestart }) => {
  return (
    <div className="entry-screen welcome-screen">
      <div className="logoText">
        <h3>Welcome to the <span>FTLSAE</span> Course</h3>
      </div>
      <strong className="d-block text-primary-s fw-normal py-2">
        <i className="fa fa-graduation-cap me-1"></i> Choose Wisely
      </strong>
      <br />
      <h2 className="fw-bold text-primary-s">Click Start when ready to begin.</h2>
      <button
        name="btn"
        onClick={handlestart}
        className="btn course-start btn-primary-s px-4 py-3 my-4 w-100 text-white"
      >
        Start
      </button>

      {/* Mobile-only typography, spacing, and button size tweaks */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @media (max-width: 767.98px) {
              .welcome-screen {
                font-size: 1rem;
                padding: 1.5rem 1.25rem;
              }
              .welcome-screen h2,
              .welcome-screen h3 {
                font-size: 1.3rem;
              }
              .welcome-screen .btn {
                padding: 0.4rem 0.6rem;
                font-size: 1rem;
                margin-top: 0.75rem;
                margin-bottom: 0.75rem;
              }
              .welcome-screen br {
                display: none;
              }
            }
          `,
        }}
      />
    </div>
  );
};

export default InitialWelcomeScreen;
